'use client'

import { Button } from '@circlefin/components/lib/Button'
import { Link } from '@features/common.components/Link'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

export const Header: React.FC = () => {
  const { t } = useTranslation('faucet')
  return (
    <div className="flex h-20 w-full items-center justify-between px-6 py-5 md:px-12">
      <div>
        <Link path="/" target="_self" type="internal">
          <Image
            alt={t('common:header.logo.alt')}
            height={30}
            src="/logo-monochrome.svg"
            width={125}
          />
        </Link>
      </div>
      <div className="flex items-center justify-end space-x-2">
        <Link path="https://developers.circle.com" type="external">
          <Button size="sm" variant="secondary">
            {t('header.links.docs')}
          </Button>
        </Link>
      </div>
    </div>
  )
}
